import React from 'react';
import { Chip, Grid, Typography } from '@mui/material';
import style from "./../../assets/styles/componentStyles/userProfileStyles/userProfileStyle.module.scss";
import globalStyle from "../../assets/styles/global.module.scss"
import GlobalButton from './globalButton/button';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import GppMaybeOutlinedIcon from '@mui/icons-material/GppMaybeOutlined';
import useGenericHook from '../../hooks/useGenericHook';

interface UserPasswordSectionProps {
    isPasswordSet: boolean;
    onClickPasswordAction: () => void;
}

const UserPasswordSection: React.FC<UserPasswordSectionProps> = ({ isPasswordSet, onClickPasswordAction }) => {
    const { isScreenBelow600 } = useGenericHook();

    return (
        <Grid item xs={12}>
            <Typography className={style.passwordSectionTitle}>
                Password
            </Typography>

            <Grid
                container
                className={style.passwordStatusCard}
                alignItems="center"
                justifyContent="space-between"
                flexWrap={isScreenBelow600 ? "wrap" : "nowrap"}
                gap={isScreenBelow600 ? "12px" : "16px"}
            >
                <Grid item xs={isScreenBelow600 ? 12 : true}>
                    <Grid container alignItems="center" flexWrap="nowrap" gap="12px">
                        <Grid item className={`${style.passwordStatusIconWrap} ${isPasswordSet ? style.passwordStatusIconSet : style.passwordStatusIconNotSet}`}>
                            {isPasswordSet ? (
                                <GppGoodOutlinedIcon className={style.passwordStatusIcon} />
                            ) : (
                                <GppMaybeOutlinedIcon className={style.passwordStatusNotSetIcon} />
                            )}
                        </Grid>

                        <Grid item>
                            <Grid container gap={'3px'} direction="column">
                                <Grid item>
                                    <Grid container alignItems="center" flexWrap="nowrap" gap="8px">
                                        <Typography className={style.passwordStatusHeading}>
                                            {isPasswordSet ? "Password is already set" : "Password is not set"}
                                        </Typography>
                                        {!isPasswordSet && (
                                            <Chip
                                                label="Optional"
                                                size="small"
                                                className={style.passwordOptionalChip}
                                            />
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Typography className={style.passwordStatusSubtext}>
                                        {isPasswordSet
                                            ? "You can change your password anytime to keep your account secure."
                                            : "Set a password to skip the code based login next time you login."}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={isScreenBelow600 ? 12 : "auto"} className={isScreenBelow600 ? globalStyle.fullwidth : undefined}>
                    <GlobalButton
                        buttonText={isPasswordSet ? "Update Password" : "Set Password"}
                        className='borderedButtonStyle'
                        sx={{ width: isScreenBelow600 ? "100%" : "auto", whiteSpace: "nowrap", px: "16px", fontSize: '13px !important' }}
                        onClick={onClickPasswordAction}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default UserPasswordSection;
